import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import productImage from "./Firefly.png";
import productImage2 from "./Gemini_Generated_Image_fh9spxfh9spxfh9s.png";
import "./App.css";

function MangoPulp({ addToCart, removeFromCart, cart = [] }) {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("all");

  const mangoPulps = [
    {
      id: 1,
      name: "Kesar Mango Pulp 1 Kg",
      price: 210,
      image: productImage,
      inStock: true,
      description:
        "Pure Kesar mango pulp made from fresh, handpicked mangoes."
    },
    {
      id: 2,
      name: "Kesar Mango Pulp 2 Kg",
      price: 420,
      image: productImage2,
      inStock: true,
      description:
        "Rich and natural Kesar mango pulp with authentic taste."
    },
    {
      id: 3,
      name: "Kesar Mango Pulp 3 Kg",
      price: 580,
      image: productImage2,
      inStock: true,
      description:
        "Premium quality Kesar mango pulp for bulk usage."
    },
    {
      id: 4,
      name: "Kesar Mango Pulp 1 Kg-24pack",
      price: 4600,
      image: productImage,
      inStock: true,
      description:
        "Bulk pack for hotels and restaurants."
    },
    {
      id: 5,
      name: "Kesar Mango Pulp 2 Kg-8pack",
      price: 3100,
      image: productImage2,
      inStock: true,
      description:
        "Bulk supply with premium taste."
    },
    {
      id: 6,
      name: "Kesar Mango Pulp 3 Kg-6pack",
      price: 3240,
      image: productImage2,
      inStock: true,
      description:
        "Ideal for commercial kitchens."
    }
  ];

  const handleAddToCart = (item) => {
    addToCart(item);
    navigate("/cart");
  };

  const getQty = (id) =>
    cart.filter((item) => item.id === id).length;

  const filteredProducts =
    filter === "all"
      ? mangoPulps
      : filter === "instock"
      ? mangoPulps.filter((p) => p.inStock)
      : mangoPulps.filter((p) => !p.inStock);

  return (
    <>
      <h2 className="page-title">🥭 Mango Pulp Products</h2>

      {/* FILTER BUTTONS */}
      <div className="filter-buttons">
        <button onClick={() => setFilter("all")}>All</button>
        <button onClick={() => setFilter("instock")}>In Stock</button>
        <button onClick={() => setFilter("outstock")}>Out of Stock</button>
      </div>

      <div className="product-grid">
        {filteredProducts.map((item) => {
          const qty = getQty(item.id);

          return (
            <div
              className={`product-card ${!item.inStock ? "out-stock" : ""}`}
              key={item.id}
            >
              <div className="image-wrapper">
                <img src={item.image} alt={item.name} />
                {!item.inStock && (
                  <span className="out-stock-badge">Out of Stock</span>
                )}
              </div>

              <h3>{item.name}</h3>
              <p className="price">₹{item.price}</p>
              <p className="product-desc">{item.description}</p>

              {item.inStock ? (
                qty === 0 ? (
                  <button
                    className="add-to-cart-btn"
                    onClick={() => handleAddToCart(item)}
                  >
                    Add to Cart
                  </button>
                ) : (
                  <div className="qty-control">
                    <button
                      className="qty-btn"
                      onClick={() => removeFromCart(item.id)}
                    >
                      −
                    </button>
                    <span className="qty-count">{qty}</span>
                    <button
                      className="qty-btn"
                      onClick={() => handleAddToCart(item)}
                    >
                      +
                    </button>
                  </div>
                )
              ) : (
                <button className="out-stock-btn" disabled>
                  Not Available
                </button>
              )}
            </div>
          );
        })}
      </div>

      <div className="view-cart-wrapper">
        <button
          className="view-cart-btn"
          onClick={() => navigate("/cart")}
        >
          🛒 View Cart
        </button>
      </div>
    </>
  );
}

export default MangoPulp;
